(function () {
    "use strict";

    angular
        .module("app")
        .directive('layoutFields', layoutFields)
        .directive('trustedHtml', trustedHtml);

    function layoutFields($rootScope, $compile, $templateRequest, $sce) {

        var isFactoryUser = $rootScope.currentUser.isFactoryUser;

        return {
            restrict: 'A',
            scope: false,
            link: function (scope, ele, attrs) {
                var moduleId = attrs.layoutFields;
                var url = false;
                switch (moduleId) {
                    case '2':
                        url = $sce.getTrustedResourceUrl(templateUrl('app/directives/hiddenFields/briefFields.directive.html'));
                        break;
                    case '3':
                        url = $sce.getTrustedResourceUrl(templateUrl('app/directives/hiddenFields/patternFields.directive.html'));
                        break;
                    case '4':
                        url = $sce.getTrustedResourceUrl(templateUrl('app/directives/hiddenFields/colorwayFields.directive.html'));
                        break;
                }

                if (url === false)
                    return;

                $templateRequest(url).then(function (template) {
                    var stripped = template.replace(/[\n\r\t]/g, '');
                    var fields = angular.element(stripped);
                    
                    scope.fields = [];
                    var row = -1;
                    angular.forEach(fields, function (k, v) {
                        var id = parseInt(k.id);

                        if (k.attributes.inactive || k.attributes.factoryUserHidden && isFactoryUser) {
                            return; //dont do anything if inactive
                        }
                        if (k.id >= 1000) {
                            var html = "<p></p>";
                            var label = "Blank Line";
                        } else {
                            var html = k.innerHTML;
                            var label = k.querySelector('p').childNodes[0].data;
                        }
                        row++;
                        scope.fields.push({
                            FieldId: id,
                            ModuleId: parseInt(moduleId),
                            UserId: parseInt($rootScope.userId),
                            row: row,
                            rowStage: row,
                            col: 0,
                            html: html,
                            class: k.className,
                            Label: label,
                            Hidden: false
                        });
                    });
                    console.log('fields', scope.fields)
                    var rpt = angular.element('<div ng-repeat="field in fields | orderBy: \'row\' | filter: {Hidden: false}" class="{{field.class}}" trusted-html="field.html" id="{{field.FieldId}}"></div>');
                    
                    ele.append(rpt);
                    $compile(rpt)(scope);
                    
                }, function () {
                    // template not found
                });
            },
            //templateUrl: ''
        };
    }

    function trustedHtml($compile) {
        return {
            restrict: 'A',
            link: function (scope, ele, attrs) {
                var e = scope.$eval(attrs.trustedHtml);
                var html = angular.element(e);

                var select = html.find('select');
                var input = html.find('input');
                var textarea = html.find('textarea');
                var button = html.find('button');
                var sh = e.indexOf('search-help');

                function disable(ele) {
                    angular.forEach(ele, function (k, v) {
                        if (ele[v].attributes['ng-disabled']) {
                            ele[v].attributes['ng-disabled'].nodeValue += ' || !editMode';
                        } else {
                            if (!ele[v].attributes['disabled']) {
                                var att = document.createAttribute("ng-disabled");
                                att.value = "!editMode";
                                ele[v].setAttributeNode(att);
                            }
                        }
                    });
                }

                function readonly(ele) {
                    angular.forEach(ele, function (k, v) {
                        if (ele[v].attributes['ng-readonly']) {
                            ele[v].attributes['ng-readonly'].nodeValue += ' || !editMode';
                        } else {
                            ele[v].attributes['ng-readonly'] = '!editMode';
                        }
                    });
                }


                if (select.length || input.length || button.length || sh > -1) { //ng-disabled
                    ele[0].style.height = "70px";
                    disable(select);
                }

                if (textarea.length) { //ng-disabled
                    readonly(textarea);
                }

                ele.append(html);
                $compile(html)(scope);
            },
            scope: false
        }
    }
})();
